<template>
  <el-dialog
    v-if="dialogVisible"
    title="预览图片"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="cancelHandler"
    append-to-body
  >
    <div class="container">
      <img :src="imgUrl" style="width: 100%; height: auto" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelHandler" type="primary">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'ViewImgDialog',
    data() {
      return {
        dialogVisible: false,
        imgUrl: null,
      };
    },
    methods: {
      openDialog(imgUrl) {
        this.imgUrl = imgUrl;
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
        this.imgUrl = null;
      },
      // 关闭弹框
      closeDialogHandler() {
        this.cancelHandler();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
